// WATestSendButton.jsx — زر «إرسال تجربة» موحّد v1 2026-09
// يُوضع بجوار أي زر إرسال حقيقي. يرسل نفس الرسالة المركَّبة لأرقام الاختبار
// المحفوظة (SSOT) عبر message_kind="test" — لا يمسّ الجمهور ولا السقف.
//
// props.getPayload(): () => { template_name, language?, body_params_keys?, components?, source_label }
//   يُعيد null/undefined لمنع الإرسال (مثلاً لا قالب مختار).
import React, { useState } from "react";
import { api, formatErr } from "./lib/api";
import { showToast } from "./lib/theme";
import { pollDeliveryTruth, deliveryTruthLabel } from "./lib/waDeliveryTruth";
import { InfoTip } from "./components/InfoTip";

export default function WATestSendButton({ getPayload, disabled, testid = "wa-test-send-btn", label = "📤 إرسال تجربة" }) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    let payload;
    try { payload = getPayload ? getPayload() : null; } catch { payload = null; }
    if (!payload || !payload.template_name) {
      showToast({ kind: "warning", message: "اختر قالبًا معتمدًا أولًا قبل التجربة." });
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/wa-test/send", {
        template_name: payload.template_name,
        language: payload.language || "ar",
        body_params_keys: payload.body_params_keys || null,
        components: payload.components || null,
        header_image_id: payload.header_image_id || null,
        source_label: payload.source_label || "إرسال",
      });
      // بند 1 (2026-10-08) — «قُبلت لدى Meta» فقط إلى أن تصل حقيقة الويب هوك
      // بالـwamid. ممنوع «✅» قبل التسليم الفعلي.
      showToast({ kind: "info", message: `⏳ قُبلت ${data.sent}/${data.total} لدى Meta — بانتظار التسليم…` });
      const accepted = (data.results || []).filter((r) => r.sent && r.message_id);
      const failedAtApi = (data.results || []).filter((r) => !r.sent);
      const truths = await Promise.all(accepted.map(async (r) => {
        const d = await pollDeliveryTruth(r.message_id, { maxTries: 5, intervalMs: 3000 });
        return `${r.name}:${deliveryTruthLabel(d)}`;
      }));
      const failedNames = failedAtApi.map((r) => `${r.name}:❌ لم تُقبَل (${r.error || "فشل"})`);
      const all = [...truths, ...failedNames].join(" · ");
      const anyFailed = truths.some((t) => t.includes("❌")) || failedNames.length > 0;
      showToast({ kind: anyFailed ? "warning" : "success", message: `🧪 نتيجة التجربة الحقيقية: ${all}` });
    } catch (e) {
      showToast({ kind: "danger", message: e?.response?.data?.detail || formatErr(e) });
    } finally { setBusy(false); }
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={run}
      disabled={busy || disabled}
 
      style={{
        border: "1px dashed #0e7490", color: "#0e7490", background: "rgba(14,116,144,0.06)",
        borderRadius: 999, minHeight: 40, padding: "8px 16px", fontSize: 13, fontWeight: 700,
        opacity: busy || disabled ? 0.6 : 1, cursor: busy || disabled ? "not-allowed" : "pointer",
      }}
     aria-label="يرسل الرسالة نفسها لأرقام الاختبار المحفوظة فقط — لا يمسّ الجمهور الحقيقي">
      {busy ? "⏳ جارٍ التجربة…" : label}
    </button>
  );
}
